import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    settings: null,
    isLoading: false
};

const userSettingsSlice = createSlice({
    name: "userSettings",
    initialState,
    reducers: {
        loadUserSettingsStart(state) {
            state.isLoading = true;
        },
        loadUserSettingsSuccess(state, action) {
            state.settings = action.payload || {};
            state.isLoading = false;
        },
        loadUserSettingsFailure(state) {
            state.isLoading = false;
        },
        updateUserSettingsSuccess(state, action) {
            state.settings = action.payload || {};
        }
    }
});

export const {
    loadUserSettingsStart,
    loadUserSettingsSuccess,
    loadUserSettingsFailure,
    updateUserSettingsSuccess
} = userSettingsSlice.actions;

export default userSettingsSlice.reducer;

export const fetchUserSettings = () => async (dispatch) => {
    dispatch(loadUserSettingsStart());
    try {
        const response = await fetch("/api/user/settings");
        if (!response.ok) {
            dispatch(loadUserSettingsFailure());
            return;
        }
        const json = await response.json();
        dispatch(loadUserSettingsSuccess(json));
    } catch (error) {
        console.log(error);
        dispatch(loadUserSettingsFailure());
    }
};

export const saveUserSettings = (settings, onSuccess, onError) => async (dispatch) => {
    try {
        const response = await fetch("/api/user/settings", {
            method: "PUT",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(settings || {})
        });
        if (!response.ok) {
            if (onError) {
                onError(new Error(`Failed to save settings (${response.status})`));
            }
            return;
        }
        const json = await response.json();
        dispatch(updateUserSettingsSuccess(json));
        if (onSuccess) {
            onSuccess(json);
        }
    } catch (error) {
        console.log(error);
        if (onError) {
            onError(error);
        }
    }
};

export const selectUserSettings = (state) => state.userSettingsSlice.settings;
export const selectUserSettingsLoading = (state) => state.userSettingsSlice.isLoading;
